import React, { useState, useEffect } from 'react';
import S3 from 'aws-sdk/clients/s3';

import { TabMenu } from 'primereact/tabmenu';
import { BreadCrumb } from 'primereact/breadcrumb';

import MachineDetail from './MachineDetail';
import MachineIngredient from './MachineIngredient';
import MachineIngredientRequirements from './MachineIngredientRequirements.jsx';
import MachineMovies from './MachineMovies';
import MachineRecipesTest from './MachineRecipes.jsx';

import './MachineInfo.css';
import Alert from '../utils/Alert';
import MachineStatus from './MachineStatus';
import MachineLocation from './Location/MachineLocation.jsx';

const MachineInfo = (props) => {
	const [machineName] = useState(
		props.location.state.customerName ? props.location.state.customerName : props.location.state.name,
	);
	const [changeWarning, setChangeWarning] = useState(false);
	const [activeItem, setActiveItem] = useState('Details');
	const [activeIndex, setActiveIndex] = useState(0);
	const [showStatusTab, setShowStatusTab] = useState(false);
	const [screenshotData, setScreenshotData] = useState(null);

	const home = { icon: 'pi pi-home', url: '/' };
	const breadCrumbItems = [{ label: 'Machines', url: '/machines' }, { label: machineName }];

	const items = [
		{
			label: 'Details',
			icon: 'pi pi-fw pi-info',
			command: () => {
				setActiveItem('Details');
				setActiveIndex(0);
			},
		},
		{
			label: 'Flavors',
			icon: 'pi pi-fw pi-pencil',
			command: () => {
				setActiveItem('Flavors');
				setActiveIndex(1);
			},
		},
		{
			label: 'Recipes',
			icon: 'pi pi-fw pi-list',
			command: () => {
				setActiveItem('Recipes');
				setActiveIndex(2);
			},
		},
		{
			label: 'Ingredient Forecast',
			icon: 'pi pi-fw pi-chart-line',
			command: () => {
				setActiveItem('Ingredient Forecast');
				setActiveIndex(3);
			},
		},
		{
			label: 'Movies',
			icon: 'pi pi-fw pi-video',
			command: () => {
				setActiveItem('Movies');
				setActiveIndex(4);
			},
		},
		{
			label: 'Location',
			icon: 'pi pi-fw pi-map-marker',
			command: () => {
				setActiveItem('Location');
				setActiveIndex(5);
			},
		},
	];

	const statusLabel = {
		label: 'Status',
		icon: 'pi pi-fw pi-check-circle',
		command: () => {
			setActiveItem('Status');
			setActiveIndex(6);
		},
	};

	useEffect(() => {
		const machineId = props.location.state.machineId;
		console.log('getting image for machineId ', machineId);

		const s3 = new S3({
			region: 'eu-west-1',
		});

		// get the image for the current machine using the id from the props
		const fetchImage = async () => {
			try {
				const data = await s3
					.makeUnauthenticatedRequest('getObject', {
						Bucket: 'static.alberts.be',
						Key: `machine-screen-states/${machineId}.png`,
					})
					.promise();

				if (data) {
					setShowStatusTab(true);
					setScreenshotData(data);
				}
			} catch (err) {
				console.log('err', err);
			}
		};

		fetchImage();

		return () => {
			setShowStatusTab(false);
			setScreenshotData(null);
		};
	}, [props.location.state.machineId]);

	return (
		<div>
			<div className="header-menu">
				<div className="menu">
					<BreadCrumb model={breadCrumbItems} home={home} />
				</div>
				<TabMenu
					model={showStatusTab ? [...items, statusLabel] : items}
					onTabChange={(e) => {
						setActiveItem(e.value.label);
					}}
					activeIndex={activeIndex}
				></TabMenu>
			</div>

			<Alert />

			<div className="">
				{activeItem === 'Details' && <MachineDetail {...props}></MachineDetail>}
				{activeItem === 'Flavors' && (
					<MachineIngredient
						{...props}
						changeWarning={changeWarning}
						setChangeWarning={setChangeWarning}
					></MachineIngredient>
				)}
				{activeItem === 'Recipes' && <MachineRecipesTest {...props}></MachineRecipesTest>}
				{activeItem === 'Ingredient Forecast' && (
					<MachineIngredientRequirements {...props}></MachineIngredientRequirements>
				)}
				{activeItem === 'Movies' && <MachineMovies {...props}></MachineMovies>}
				{showStatusTab && activeItem === 'Status' && (
					<MachineStatus {...props} screenshotData={screenshotData}></MachineStatus>
				)}
				{activeItem === 'Location' && <MachineLocation {...props}></MachineLocation>}
			</div>
		</div>
	);
};

export default MachineInfo;
